/**
 * Renders a blog cover image with graceful onError fallback.
 * If the underlying file is missing on disk (common after a production
 * redeploy that wipes the ephemeral uploads/ directory) the broken-image
 * is replaced by a soft navy→gold gradient placeholder with the article
 * title as a watermark — never showing the browser's broken-image icon
 * or raw alt text.
 */
import { useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BlogCoverImage({ src, alt, className = "", placeholderClassName = "" }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={`${className} ${placeholderClassName} bg-gradient-to-br from-navy via-navy/90 to-gold/30 flex items-center justify-center`}
        data-testid="blog-cover-placeholder"
      >
        <p className="font-playfair text-white/85 text-base sm:text-lg font-semibold px-6 text-center line-clamp-3 max-w-md">
          {alt || "RoleIQ Editorial"}
        </p>
      </div>
    );
  }

  const finalSrc = src.startsWith("http") ? src : `${API}${src}`;

  return (
    <img
      src={finalSrc}
      alt={alt}
      onError={() => setFailed(true)}
      className={className}
      data-testid="blog-cover-image"
    />
  );
}
